import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import BaseBadge from '../BaseBadge';
import styles from './styles.scss';

const ClearingBadge = ({ clearing, className, ...rest }) => {
  // should do nothing if clearing is empty
  if (_.isEmpty(clearing)) return null;

  const [label, styleKey] = (() => {
    const total = clearing.payment_amount - clearing.invoice_amount;
    if (total > 0) {
      return ['支払', 'payment-badge'];
    } else if (total < 0) {
      return ['請求', 'invoice-badge'];
    } else if (total === 0) {
      return ['精算なし', 'no-clearing-badge'];
    }
  })();
  const mergedClassName = `${styles[styleKey]} ${className}`;
  return (
    <BaseBadge className={mergedClassName} {...rest}>{label}</BaseBadge>
  );
};

ClearingBadge.propTypes = {
  clearing: PropTypes.shape({ payment_amount: PropTypes.number, invoice_amount: PropTypes.number }).isRequired,
  className: PropTypes.string,
};

ClearingBadge.defaultProps = {
  className: '',
};

export default ClearingBadge;
